import { useState } from "react";
import styled from "styled-components";
import { useAddAccessLevel } from "../../hooks/useManagement";
import Button from "../Button/Button";
import { InputField1 } from "../InputField1/InputField1";
import Typography from "../Typography/Typography";

const initvalue = {
  Phone: null,
  FirstName: null,
  LastName: null,
  profile: null,
  password: null,
  UnitAccounting: null,
  UnitContent: null,
  UnitCRM: null,
  UnitManagement: null,
};
function AccessLevelForm() {
  const [form, setForm] = useState(initvalue);
  const { mutateAsync: AddUser } = useAddAccessLevel();

  const handleAddUser = async () => {
    const user = new FormData();
    user.append("Phone", form.Phone);
    user.append("FirstName", form.FirstName);
    user.append("LastName", form.LastName);
    user.append("profile", form.profile);
    user.append("password", form.password);
    user.append("UnitAccounting", form.UnitAccounting);
    user.append("UnitContent", form.UnitContent);
    user.append("UnitCRM", form.UnitCRM);
    user.append("UnitManagement", form.UnitManagement);
    user.append("password", form.password);
    await AddUser(user).then(() => setForm(initvalue));
  };
  return (
    <AccessLevelStyle>
      <div className="row">
        <div className="col-12 mb-2">
          <Typography>تعریف همکار</Typography>
        </div>
        <div className="col-lg-3 col-12">
          <InputField1
            type="file"
            label="عکس پروفایل"
            onChange={(e) => setForm({ ...form, profile: e.target.files[0] })}
          />
        </div>
        <div className="col-lg-3 col-12">
          <InputField1
            placeholder="نام را وارد کنید"
            label="نام"
            onChange={(e) => setForm({ ...form, FirstName: e.target.value })}
            value={form.FirstName}
          />
        </div>
        <div className="col-lg-3 col-12">
          <InputField1
            placeholder="نام خانوادگی را وارد کنید"
            label="نام خانوادگی"
            onChange={(e) => setForm({ ...form, LastName: e.target.value })}
            value={form.LastName}
          />
        </div>
        <div className="col-lg-3 col-12">
          <InputField1
            placeholder="شماره موبایل را وارد کنید"
            label="شماره موبایل"
            onChange={(e) => setForm({ ...form, Phone: e.target.value })}
            value={form.Phone}
          />
        </div>
        <div className="col-lg-3 col-12">
          <InputField1
            placeholder="رمز عبور"
            label="رمز عبور"
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            value={form.password}
          />
        </div>
        <div className="col-12">
          <div className="row mt-3">
            <div className="col-12 mb-2">
              <Typography>دسترسی ها</Typography>
            </div>
            <div className="col-lg-3 col-12">
              <div className="border">
                <input
                  className="my-3 mx-2"
                  type="checkbox"
                  id="accounting"
                  name="accounting"
                  onChange={(e) =>
                    setForm({
                      ...form,
                      UnitAccounting: e.target.checked ? "on" : "empty",
                    })
                  }
                  checked={form.UnitAccounting === "on" ? true : false}
                />
                <label for="accounting">واحد حسابداری</label>
              </div>
            </div>
            <div className="col-lg-3 col-12">
              <div className="border">
                <input
                  className="my-3 mx-2"
                  type="checkbox"
                  id="content"
                  name="content"
                  onChange={(e) =>
                    setForm({
                      ...form,
                      UnitContent: e.target.checked ? "on" : "empty",
                    })
                  }
                  checked={form.UnitContent === "on" ? true : false}
                />
                <label for="content">واحد محتوا</label>
              </div>
            </div>
            <div className="col-lg-3 col-12">
              <div className="border">
                <input
                  className="my-3 mx-2"
                  type="checkbox"
                  id="crm"
                  name="crm"
                  onChange={(e) =>
                    setForm({
                      ...form,
                      UnitCRM: e.target.checked ? "on" : "empty",
                    })
                  }
                  checked={form.UnitCRM === "on" ? true : false}
                />
                <label for="crm">واحد CRM</label>
              </div>
            </div>
            <div className="col-lg-3 col-12">
              <div className="border">
                <input
                  className="my-3 mx-2"
                  type="checkbox"
                  id="managing"
                  name="managing"
                  onChange={(e) =>
                    setForm({
                      ...form,
                      UnitManagement: e.target.checked ? "on" : "empty",
                    })
                  }
                  checked={form.UnitManagement === "on" ? true : false}
                />
                <label for="managing">واحد مدیریت</label>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-12 col-12 mt-lg-1 mt-3">
          <Button
            bgColor="#009ef7"
            small="70px"
            color="#fff"
            onclick={() => handleAddUser(form)}
          >
            ثبت
          </Button>
        </div>
      </div>
    </AccessLevelStyle>
  );
}

export default AccessLevelForm;
const AccessLevelStyle = styled.div`
  margin-top: 20px;
  background-color: ${({ theme }) => theme.box};
  padding: 10px;
  border-radius: 10px;
  box-shadow: ${({ theme }) => theme.shadow};
`;
